export default {
  name: 'WeibyInput',
  props: {
    autocomplete: {
      default: 'on',
      type: String,
    },
    disabled: Boolean,
    label: {
      default: '',
      type: String,
    },
    labelClass: {
      default: '',
      type: String,
    },
    max: Number,
    message: {
      default: '',
      type: String,
    },
    passwordReveal: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    showCount: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    showSuccess: {
      default: false,
      type: Boolean,
    },
    type: {
      default: 'text',
      type: String,
    },
    value: {
      default: '',
      type: [String, Number],
    },
    variant: {
      default: null,
      type: [null, String],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    currentType() {
      if (this.passwordReveal) {
        return this.show ? 'text' : 'password';
      }
      return this.type;
    },
    getVariant() {
      const arr = [
        {
          show: this.showError,
          type: 'error',
        },
        {
          show: this.showSuccess,
          type: 'success',
        },
      ];

      return arr.find(({ show }) => show)?.type || this.variant;
    },
    iconDefaultClass() {
      return `
        absolute
        flex
        inset-y-0
        items-center
        leading-5
        pr-3
        right-0
      `;
    },
    textCount() {
      return this.value?.length || 0;
    },
  },
};
